import React, { useContext, useEffect, useRef, useState } from "react";
import cytoscape from "cytoscape";
import dagre from "dagre";
import cyDagre from "cytoscape-dagre";
import { gangDetectionAction } from "../../_actions/gang.detection.actions";
import { useParams } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import {
  Card,
  Typography,
  Divider,
  Spin,
  Table,
  Row,
  Col,
  Button,
  Modal,
} from "antd";

import {
  AppstoreOutlined,
  BarChartOutlined,
  BulbOutlined,
  EnvironmentOutlined,
  SafetyOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { professionalAction } from "../../_actions";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";

const { Title, Text, Paragraph } = Typography;

// Register Dagre
cyDagre(cytoscape);

const GraphView = (props) => {
  const { match, dispatch, professionals } = props;
  const { t } = useContext(LanguageContext);
  const params = useParams();

  const id = match?.params?.id || params?.id;

  const cyRef = useRef(null); // Graph container
  const cyInstance = useRef(null); // Cytoscape instance

  const [gangDetails, setGangDetails] = useState();
  const [graphData, setGraphData] = useState(null);
  const [isIsolated, setIsIsolated] = useState(false);
  const [loader, setLoader] = useState(false);

  const [viewCrimeProfile, setViewCrimeProfile] = useState(false);
  const [gunaLoading, setGunaLoading] = useState(false);
  const [gunaView, setgunaView] = useState(false);

  const handleCrimeProfile = (id) => {
    setViewCrimeProfile(true);
    dispatch(professionalAction.getCriminalsViewsById(id));
  };

  const closeCrimeProfile = () => {
    setViewCrimeProfile(false);
  };

  const handleGunaView = (id) => {
    setgunaView(true);
    setGunaLoading(true);
    dispatch(professionalAction.getCriminalsViewsById(id));
  };

  const closeGunaView = () => {
    setgunaView(false);
  };

  /* ------------------- API CALLS ------------------- */

  const getGangDetails = () => {
    gangDetectionAction.getGangDetails({ gang_id: id }).then((res) => {
      setGangDetails(res.data.gang);
    });
  };

  const getGraph = () => {
    setLoader(true);

    gangDetectionAction.getGraph({ id }).then((res) => {
      const data = res.data;

      if (!data || !data.nodes || data.nodes.length === 0) {
        setIsIsolated(true);
        setLoader(false);
        return;
      }

      const nodes = data.nodes.map((n) => ({ data: { ...n.data } }));
      const edges = data.edges.map((e) => ({ data: { ...e.data } }));

      setGraphData({ nodes, edges });
      setLoader(false);
    });
  };
  useEffect(() => {
    dispatch(professionalAction.getAllMaster());
    props.dispatch(professionalAction.getCity());
    props.dispatch(professionalAction.getDharm());
    props.dispatch(professionalAction.getKalam());
    props.dispatch(professionalAction.getKayda());
    props.dispatch(professionalAction.getCrimeType());
    props.dispatch(professionalAction.getCrimeTitle());
    props.dispatch(professionalAction.getStatus());
  }, []);

  useEffect(() => {
    if (id) {
      getGraph();
      getGangDetails();
    }
  }, [id]);

  useEffect(() => {
    // If gunaLoading is true and we have received new data, stop loading
    if (
      gunaLoading &&
      props.professionals?.criminalViewList &&
      Object.keys(props.professionals.criminalViewList).length > 0
    ) {
      setGunaLoading(false);
    }
  }, [props.professionals?.criminalViewList]);

  /* ------------------- GRAPH RENDER ------------------- */

  useEffect(() => {
    if (!graphData || isIsolated || !cyRef.current) return;

    const cy = cytoscape({
      container: cyRef.current,
      elements: [...graphData.nodes, ...graphData.edges],

      style: [
        {
          selector: "node",
          style: {
            label: "data(label)",
            "background-color": "#ffb3b3",
            "border-color": "#e60000",
            "border-width": 2,
            color: "#000",
            "font-weight": "bold",
            "text-valign": "center",
            "text-halign": "center",
            shape: "round-rectangle",
            width: 140,
            height: 40,
            "text-wrap": "wrap",
          },
        },
        {
          selector: "edge",
          style: {
            label: "data(label)",
            "curve-style": "bezier",
            "target-arrow-shape": "triangle",
            "line-color": "#888",
            "target-arrow-color": "#888",
            "font-size": 10,
            "text-background-color": "#fff",
            "text-background-opacity": 1,
            "text-background-shape": "roundrectangle",
          },
        },
      ],

      layout: {
        name: "dagre",
        rankDir: "LR",
        padding: 50,
        nodeSep: 80,
        edgeSep: 40,
        rankSep: 100,
        animate: true,
      },
    });

    cyInstance.current = cy;

    setTimeout(() => cy.fit(), 200);

    return () => {
      cy.destroy();
      cyInstance.current = null;
    };
  }, [graphData, isIsolated]);

  /* ------------------- ZOOM CONTROLS ------------------- */

  const zoomIn = () => {
    const cy = cyInstance.current;
    if (!cy) return;
    cy.zoom({
      level: cy.zoom() * 1.2,
      renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
    });
  };

  const zoomOut = () => {
    const cy = cyInstance.current;
    if (!cy) return;
    cy.zoom({
      level: cy.zoom() * 0.8,
      renderedPosition: { x: cy.width() / 2, y: cy.height() / 2 },
    });
  };

  const resetZoom = () => {
    cyInstance.current?.fit();
  };

  /* ------------------- gangDetails.table ------------------- */
  /* =========================
     1. MEMBERS TABLE
     ========================= */
  const memberColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: t("name"),
      dataIndex: "name",
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => {
            handleCrimeProfile(record.criminal_id);
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: t("police_station"),
      dataIndex: "districtname",
    },
    {
      title: t("total_crimes"),
      dataIndex: "total_crimes",
      render: (text, record) => (
        <Button
          onClick={() => {
            handleGunaView(record.criminal_id);
          }}
          type="link"
        >
          {text}
        </Button>
      ),
    },
  ];
  /* =========================
     2. Heading Table
     ========================= */
  const headingColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },

    {
      title: t("title"),
      dataIndex: "crime_title",
    },
    {
      title: "Fir",
      dataIndex: "fir",
    },
  ];
  const handleCommonCriminalClick = (id, record) => {
    console.log("Row data:", record, id);
    handleCrimeProfile(id);
    // example:
    // dispatch(getCommonCriminals(record.source_fir, record.target_fir))
  };

  /* =========================
     2. YEAR COUNT TABLE
     ========================= */
  const yearCountData =
    gangDetails?.year_count?.flatMap((obj, index) =>
      Object.entries(obj).map(([year, count]) => ({
        key: `${index}-${year}`,
        year,
        count,
      }))
    ) || [];

  const yearColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: t("year"),
      dataIndex: "year",
    },
    {
      title: t("total_crimes"),
      dataIndex: "count",
    },
  ];

  /* =========================
     3. CORE / PERIPHERAL FIR
     ========================= */
  const makeFirData = (list = []) =>
    list.flatMap((obj, index) =>
      Object.entries(obj).map(([name, count]) => ({
        key: `${index}-${name}`,
        name,
        count,
      }))
    );

  const firColumns = [
    {
      title: t("sr.no"),
      render: (_, __, index) => index + 1,
      width: 80,
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: t("आरोपी"),
      dataIndex: "count",
    },
  ];

  /* =========================
     4. DYNAMIC POLICE ACTION TABLE
     ========================= */
  const tableData = gangDetails?.table || [];

  const dynamicColumns =
    tableData.length > 0
      ? [
          {
            title: t("sr.no"),
            render: (_, __, index) => index + 1,
            width: 80,
          },
          ...Object.keys(tableData[0]).map((key) => ({
            title: key.replace(/_/g, " ").toUpperCase(),
            dataIndex: key,
            key,
            ellipsis: true,
            render:
              key === "common criminals"
                ? (value, record) => {
                    if (!value) return "-";

                    const ids = value
                      .toString()
                      .split(",")
                      .map((id) => id.trim());

                    return (
                      <>
                        {ids.map((id) => (
                          <Button
                            key={id}
                            type="link"
                            onClick={() =>
                              handleCommonCriminalClick(id, record)
                            }
                          >
                            {id}
                          </Button>
                        ))}
                      </>
                    );
                  }
                : undefined,
          })),
        ]
      : [];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div
        style={{
          textAlign: "center",
          width: "100%",
          padding: "0 0 20px 0",
          fontWeight: "bold",
        }}
      >
        Gang Analysis :
      </div>
      <Card className="viewCard profile-desc">
        <div className="info-table">
          <div className="info-header">
            <div>घटक</div>
            <div>माहिती</div>
          </div>

          <div className="info-row">
            <div className="info-label">👥 Total Members</div>
            <div className="info-value">
              किमान {gangDetails?.members?.length} प्रमुख आरोपी
            </div>
          </div>

          <div className="info-row">
            <div className="info-label">📁 FIR Count</div>
            <div className="info-value">
              <b>{gangDetails?.fir?.length}</b> एकत्रितरीत्या जोडलेले
            </div>
          </div>

          <div className="info-row">
            <div className="info-label active">🗺️ Active Years</div>
            <div className="info-value">
              <b>{gangDetails?.years_active}</b>
            </div>
          </div>

          <div className="info-row">
            <div className="info-label">🎯 Key FIRs</div>
            <div className="info-value">
              {gangDetails?.firs &&
                gangDetails?.firs.length > 0 &&
                gangDetails?.firs.map((fi, index) => (
                  <>
                    {fi}
                    {","}
                  </>
                ))}
            </div>
          </div>
        </div>
      </Card>

      {/* GRAPH CARD */}
      <div
        style={{
          position: "relative",
          height: "80vh",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        {/* ZOOM BUTTONS */}
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          <button style={zoomBtnStyle} onClick={zoomIn}>
            +
          </button>
          <button style={zoomBtnStyle} onClick={zoomOut}>
            −
          </button>
          <button style={zoomBtnStyle} onClick={resetZoom}>
            ⟳
          </button>
        </div>

        {isIsolated ? (
          <div className="p-6 text-center">No connected FIR found</div>
        ) : (
          <>
            <div
              style={{
                border: "2px solid #d9d9d9",
                borderRadius: "12px",
                height: "100%",
                position: "relative",
                background: "#fff",
              }}
            >
              <Spin spinning={loader} />
              <div ref={cyRef} style={{ width: "100%", height: "100%" }} />
            </div>
          </>
        )}
      </div>

      {/* ANALYSIS SECTION */}
      <div className="p-10 bg-gray-50 min-h-screen">
        <Card className="max-w-5xl mx-auto shadow-xl rounded-2xl">
          <Title level={3}>
            <BarChartOutlined /> गँग नेटवर्कचे विश्लेषण
          </Title>

          <Divider />

          {/* ========================= MEMBERS ========================= */}
          <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
            {/* Left Column */}
            <Col xs={24} md={12}>
              <Title level={4}>
                <TeamOutlined /> सदस्य संख्या (Gang Members)
              </Title>

              <Table
                rowKey={(record, index) => index}
                columns={memberColumns}
                dataSource={gangDetails?.members || []}
                bordered
                loading={loader}
                pagination={{ showSizeChanger: true }}
              />
            </Col>

            {/* Right Column */}
            <Col xs={24} md={12}>
              <Title level={4}>
                <BulbOutlined /> Headings
              </Title>

              <Table
                rowKey={(record, index) => index}
                columns={headingColumns}
                dataSource={gangDetails?.headings || []}
                bordered
                loading={loader}
                pagination={{ showSizeChanger: true }}
              />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginBottom: "10px" }}>
            <Col xs={24} md={12}>
              {/* ========================= CORE FIR ========================= */}
              <Title level={4}>
                <BulbOutlined />
                Core FIRs (जास्त Edge)
              </Title>

              <Table
                rowKey="key"
                columns={firColumns}
                dataSource={makeFirData(gangDetails?.core_fir)}
                pagination={{ showSizeChanger: true }}
                bordered
              />
            </Col>
            <Col xs={24} md={12}>
              {/* ========================= PERIPHERAL FIR ========================= */}
              <Title level={4}>
                <BulbOutlined /> Peripheral FIRs (कमी Edge)
              </Title>

              <Table
                rowKey="key"
                columns={firColumns}
                dataSource={makeFirData(gangDetails?.pheripheral_fir)}
                pagination={{ showSizeChanger: true }}
                bordered
              />

              <Divider />
            </Col>
          </Row>

          <Divider />

          {/* ========================= YEAR COUNT ========================= */}
          <Title level={4}>
            <EnvironmentOutlined />
            कार्यक्षेत्र (Year-wise Activity)
          </Title>

          <Table
            rowKey="key"
            columns={yearColumns}
            dataSource={yearCountData}
            pagination={{ showSizeChanger: true }}
            bordered
          />

          <Divider />

          {/* ========================= POLICE ACTION ========================= */}
          <Title level={4}>
            <SafetyOutlined /> Insights for Police Action
          </Title>

          <Table
            rowKey={(record, index) => index}
            columns={dynamicColumns}
            dataSource={tableData}
            pagination={{ showSizeChanger: true }}
            bordered
          />
        </Card>
      </div>
      <Modal
        title="आरोपी प्रोफाइल"
        top
        visible={viewCrimeProfile}
        onOk={closeCrimeProfile}
        onCancel={closeCrimeProfile}
        width={95 + "%"}
      >
        <ViewFormModel
          key={props && props.user.id}
          dataStates={props.professionals}
        ></ViewFormModel>
      </Modal>
      <Modal
        title={t("crime_information")}
        top
        visible={gunaView}
        onOk={closeGunaView}
        onCancel={closeGunaView}
        width={95 + "%"}
      >
        <ViewGunaDetails
          pc_crimetitles={professionals?.pc_crimetitles}
          dataStates={
            Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
            professionals?.criminalViewList?.gunhaInfor.length > 0
              ? professionals?.criminalViewList?.gunhaInfor
              : []
          }
          name={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].name
              : ""
          }
          address={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].address
              : ""
          }
          loading={gunaLoading}
          user_details={props?.user}
          masterId={
            Array.isArray(professionals?.criminalViewList?.basicInfo) &&
            professionals?.criminalViewList?.basicInfo[0]
              ? professionals?.criminalViewList?.basicInfo[0].id
              : ""
          }
          closeGunaViewModel={closeGunaView}
        ></ViewGunaDetails>
      </Modal>
    </div>
  );
};

const zoomBtnStyle = {
  width: 36,
  height: 36,
  borderRadius: 6,
  border: "1px solid #d9d9d9",
  background: "#fff",
  fontSize: 18,
  fontWeight: "bold",
  cursor: "pointer",
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

const connectedGangList = connect(mapStateToProps)(GraphView);
export { connectedGangList as GraphView };
